import { useState } from 'react';
import './App.css';
import arzook from './assets/logo.png';

const t = {
  en: {
    nav: {
      home: 'Home',
      customers: 'Our Customers',
      about: 'About Us',
      contact: 'Contact Us',
      login: 'Login',
      messages: 'Messages',
    },

    auth: {
      loginTitle: 'Welcome back',
      loginSubtitle: 'Sign in to your Cirook account',
      email: 'Email address',
      password: 'Password',
      loginButton: 'Sign in',
      forgot: 'Forgot password?',
      forgotTitle: 'Reset your password',
      forgotSubtitle:
        'Enter your email and we’ll send you a reset link.',
      sendReset: 'Send reset link',
      backLogin: 'Back to login',
      resetSent:
        'If an account exists for this email, a reset link has been sent.',
      failedMessage:
        'The email or password you entered is incorrect. Please check your credentials and try again.',
      messagesTitle: 'Messages',
      messagesSubtitle:
        'Your secure Cirook messages and notifications.',
      noMessages: 'You have no new messages.',
      signOut: 'Sign out',
    },

    tagline: `Cirook’s activity is to facilitate transactions and enable the secure transfer of funds between transaction parties through an escrow mechanism. Cirook provides a platform that allows individuals and legal entities to securely and transparently transfer and settle funds in their transactions, including the exchange of currency, goods, or other assets.

At the beginning of the process, Cirook assigns a unique payment identification code to each user so that all deposits can be continuously monitored and tracked. The transaction parties register the transaction details and the agreed amount. The received funds are held by Cirook in escrow until the transaction process is completed, and Cirook acts solely as the escrow holder of the funds.

After confirming that the parties have fulfilled their obligations, Cirook transfers the funds to the relevant beneficiary in accordance with the registered payment instruction and completes the financial settlement process.

Cirook’s role is limited to facilitating, monitoring, and executing the fund transfer and settlement process, and Cirook is not a party to the underlying transaction.`,

    open: 'Open app →',

    footer: '© 2025 Cirook Inc. All rights reserved.',

    apps: [
      {
        name: 'Arzook.ca',
        description:
          'Currency and financial tools for Iranian-Canadians',
      },
    ],

    customers: {
      title: 'Our Customers',
      subtitle:
        'Cirook provides secure and transparent financial infrastructure for businesses and digital platforms.',

      arzookTitle: 'Arzook.ca',

      arzookDescription:
        'Arzook.ca provides currency and financial tools designed for Iranian-Canadians, helping users access useful currency-related and financial services.',

      visit: 'Visit Arzook.ca →',
    },

    about: {
      title: 'About Us',

      introTitle: 'About Cirook',

      intro: `Cirook is a financial technology platform focused on facilitating secure and transparent transactions between transaction parties.

Our platform is designed to support the controlled transfer and settlement of funds through an escrow mechanism. Cirook monitors payment identification, transaction information, and settlement instructions throughout the process.

Cirook does not become a party to the underlying transaction. Our role is limited to facilitating, monitoring, and executing the transfer and settlement of funds according to the instructions registered by the transaction parties.`,

      companyInfoTitle: 'Company Information',

      companyInfo: {
        established: '2021 (1399)',
        registrationDate: 'March 3, 2021 (1399/12/13)',
        legalType: 'Limited Liability Company',
        nationalId: '14009864061',
        registrationNumber: '18341',
        registeredOffice: 'Qom, Iran',
      },

      activityTitle: 'Our Activities',

      activityText: `Cirook operates as a technology-focused company providing infrastructure and services related to secure transactions, financial settlement, payment monitoring, and electronic commerce.

The company's registered business activities include information technology consulting and implementation, data network services, e-commerce, commercial representation, marketing activities, and related technology services, subject to applicable licenses and regulatory requirements.`,

      ttpTitle: 'Trusted Third Party (TTP)',

      ttpText: `Cirook acts as a Trusted Third Party (TTP) between the parties involved in a transaction.

As a Trusted Third Party, Cirook provides an independent and transparent mechanism for monitoring, holding, and settling funds during the transaction process.

The funds received from the transaction parties are held in escrow until the agreed conditions of the transaction have been fulfilled. Once the required obligations are confirmed, Cirook executes the registered payment instruction and transfers the funds to the designated beneficiary.

Cirook does not become a party to the underlying transaction. Its role is limited to acting as a Trusted Third Party, facilitating the secure transfer, monitoring, and settlement of funds between the transaction parties.`,

      missionTitle: 'Our Mission',

      missionText:
        'Our mission is to make transactions more secure, transparent, and efficient by providing reliable technology for payment tracking, escrow, and financial settlement.',
    },

    contact: {
      title: 'Contact Us',

      subtitle:
        'For business inquiries, partnerships, or general questions, please contact us.',

      email: 'Email',

      emailValue: 'info@cirook.com',

      address: 'Towhid Blv, Qom, Iran',

      phone: '+98-910-486-8798',

      company: 'Cirook Inc.',

      message:
        'We will be happy to hear from you and discuss potential cooperation.',
    },

    store: {
      title: 'Your Store',

      subtitle:
        'A fully bilingual e-commerce platform — ready to sell worldwide',

      goToStore: 'Go to Store →',

      back: '← Back',

      features: [
        {
          icon: '🌐',
          title: 'Multi-Language',
          desc:
            'Support for English, Farsi, Arabic, and any language you add. RTL layouts included.',
        },

        {
          icon: '💰',
          title: 'Multi-Currency',
          desc:
            'Define currencies with custom symbols, decimal places, and exchange rates.',
        },

        {
          icon: '📦',
          title: 'Product Management',
          desc:
            'Add products with multi-language names, multiple prices per currency, images, and videos.',
        },

        {
          icon: '📑',
          title: 'Page Tabs',
          desc:
            'Customizable navigation tabs — About, FAQ, Contact, and any page you define.',
        },

        {
          icon: '🗂',
          title: 'Category Tree',
          desc:
            'Unlimited-depth categories to organize your products however you want.',
        },

        {
          icon: '🚚',
          title: 'Shipping & Payments',
          desc:
            'Integrated shipping rates and payment gateways.',
        },
      ],
    },
  },

  fa: {
    nav: {
      home: 'صفحه اصلی',
      customers: 'مشتریان ما',
      about: 'درباره ما',
      contact: 'ارتباط با ما',
      login: 'ورود',
      messages: 'پیام‌ها',
    },

    auth: {
      loginTitle: 'خوش آمدید',
      loginSubtitle: 'وارد حساب کاربری سیروک شوید',
      email: 'آدرس ایمیل',
      password: 'رمز عبور',
      loginButton: 'ورود',
      forgot: 'رمز عبور را فراموش کرده‌اید؟',
      forgotTitle: 'بازیابی رمز عبور',
      forgotSubtitle:
        'ایمیل خود را وارد کنید تا لینک بازیابی برای شما ارسال شود.',
      sendReset: 'ارسال لینک بازیابی',
      backLogin: 'بازگشت به ورود',
      resetSent:
        'اگر حسابی با این ایمیل وجود داشته باشد، لینک بازیابی ارسال شده است.',
      failedMessage:
        'ایمیل یا رمز عبور واردشده صحیح نیست. لطفاً اطلاعات ورود خود را بررسی کرده و دوباره تلاش کنید.',
      messagesTitle: 'پیام‌ها',
      messagesSubtitle: 'پیام‌ها و اعلان‌های امن سیروک.',
      noMessages: 'پیام جدیدی ندارید.',
      signOut: 'خروج',
    },

    tagline: `فعالیت شرکت فن آوران نواندیش سیروک، تسهیل معاملات و انتقال ایمن وجوه بین طرفین معامله از طریق سازوکار امانی است. شرکت سیروک بستری فراهم می‌کند تا اشخاص حقیقی یا حقوقی بتوانند در معاملات خود، از جمله مبادله ارز، کالا یا سایر دارایی‌ها، وجوه را به‌صورت امن و شفاف منتقل و تسویه نمایند.

در آغاز فرآیند، شرکت برای هر کاربر شناسه واریز اختصاصی تعریف می‌کند تا واریزی‌ها به‌صورت مستمر تحت رصد و پیگیری قرار گیرند. طرفین معامله اطلاعات مربوط به معامله و مبلغ مورد توافق را ثبت می‌کنند. وجوه دریافت‌شده تا زمان تکمیل فرآیند معامله به‌صورت امانی نزد شرکت نگهداری می‌شود و شرکت صرفاً نگهدارنده امانی وجوه است.

پس از تأیید انجام تعهدات طرفین معامله، شرکت فن آوران نواندیش سیروک مطابق دستور پرداخت ثبت‌شده نسبت به انتقال وجه به ذی‌نفع مربوطه اقدام کرده و فرآیند تسویه مالی را تکمیل می‌کند.

نقش شرکت فن آوران نواندیش سیروک محدود به تسهیل، کنترل و اجرای فرآیند انتقال و تسویه وجوه است و شرکت طرف معامله محسوب نمی‌شود.`,

    open: '← باز کردن',

    footer:
      'تمامی حقوق این سایت متعلق به شرکت فن آوران نواندیش سیروک است. © ۲۰۲۵',

    apps: [
      {
        name: 'Arzook.ca',
        description:
          'ابزارهای ارزی و مالی برای ایرانی‌کانادایی‌ها',
      },
    ],

    customers: {
      title: 'مشتریان ما',

      subtitle:
        'سیروک زیرساخت امن و شفاف مالی را برای کسب‌وکارها و پلتفرم‌های دیجیتال فراهم می‌کند.',

      arzookTitle: 'Arzook.ca',

      arzookDescription:
        'Arzook.ca مجموعه‌ای از ابزارهای ارزی و مالی را برای ایرانی‌کانادایی‌ها فراهم می‌کند و خدمات کاربردی مرتبط با ارز و امور مالی را در اختیار کاربران قرار می‌دهد.',

      visit: 'بازدید از Arzook.ca ←',
    },

    about: {
      title: 'درباره ما',

      introTitle: 'درباره سیروک',

      intro: `شرکت فن آوران نواندیش سیروک یک پلتفرم فناوری مالی است که با هدف تسهیل معاملات امن و شفاف میان طرفین معامله فعالیت می‌کند.

این پلتفرم برای انتقال و تسویه کنترل‌شده وجوه از طریق سازوکار امانی طراحی شده است. سیروک در طول فرآیند، شناسه پرداخت، اطلاعات معامله و دستورالعمل تسویه را کنترل و پایش می‌کند.

سیروک طرف معامله محسوب نمی‌شود و نقشی در معامله اصلی ندارد. نقش شرکت محدود به تسهیل، کنترل و اجرای فرآیند انتقال و تسویه وجوه مطابق دستور ثبت‌شده طرفین معامله است.`,

      companyInfoTitle: 'اطلاعات شرکت',

      companyInfo: {
        established: '۱۴۰۰',
        registrationDate: '۱۳۹۹/۱۲/۱۳',
        legalType: 'با مسئولیت محدود',
        nationalId: '۱۴۰۰۹۸۶۴۰۶۱',
        registrationNumber: '۱۸۳۴۱',
        registeredOffice: 'قم، ایران',
      },

      activityTitle: 'حوزه فعالیت',

      activityText: `شرکت فن آوران نواندیش سیروک یک شرکت فناوری‌محور است که در زمینه ارائه زیرساخت و خدمات مرتبط با معاملات امن، تسویه مالی، پایش پرداخت‌ها و تجارت الکترونیک فعالیت می‌کند.

موضوعات فعالیت ثبت‌شده شرکت شامل مشاوره، اجرا و پشتیبانی طرح‌های انفورماتیکی و شبکه‌های داده، تجارت الکترونیک، دلالی و حق‌العمل‌کاری و نمایندگی تجاری، بازاریابی غیرهرمی و غیرشبکه‌ای و سایر خدمات مرتبط با فناوری است که حسب مورد با رعایت قوانین و اخذ مجوزهای لازم انجام می‌شود.`,

      ttpTitle:
        'شخص ثالث مورد اعتماد (Trusted Third Party - TTP)',

      ttpText: `شرکت فن آوران نواندیش سیروک به‌عنوان یک شخص ثالث مورد اعتماد (Trusted Third Party یا TTP) میان طرفین معامله ایفای نقش می‌کند.

سیروک در جایگاه شخص ثالث مورد اعتماد، سازوکاری مستقل و شفاف برای پایش، نگهداری و تسویه وجوه در طول فرآیند معامله فراهم می‌کند.

وجوه دریافت‌شده از طرفین معامله تا زمان انجام شرایط و تعهدات مورد توافق، به‌صورت امانی نزد سیروک نگهداری می‌شود. پس از تأیید انجام تعهدات، سیروک مطابق دستور پرداخت ثبت‌شده، وجه را به ذی‌نفع تعیین‌شده منتقل می‌کند.

سیروک طرف معامله محسوب نمی‌شود و هیچ نقشی در معامله اصلی ندارد. نقش سیروک صرفاً به‌عنوان شخص ثالث مورد اعتماد، تسهیل، پایش و اجرای فرآیند انتقال و تسویه وجوه میان طرفین معامله است.`,

      missionTitle: 'ماموریت ما',

      missionText:
        'ماموریت ما ایجاد بستری امن، شفاف و کارآمد برای معاملات و تسویه مالی از طریق فناوری قابل اعتماد در حوزه پرداخت، امانت و انتقال وجوه است.',
    },

    contact: {
      title: 'ارتباط با ما',

      subtitle:
        'برای درخواست‌های تجاری، همکاری، مشارکت یا پرسش‌های عمومی می‌توانید با ما در ارتباط باشید.',

      email: 'ایمیل',

      emailValue: 'info@cirook.com',

      address: 'ایران- قم.    صندوق پستی: 95644-37179',

      phone: '+98-910-486-8798',

      company: 'شرکت فن آوران نواندیش سیروک',

      message:
        'از دریافت پیام شما خوشحال می‌شویم و آماده بررسی فرصت‌های همکاری هستیم.',
    },

    store: {
      title: 'فروشگاه شما',

      subtitle:
        'یک پلتفرم فروشگاهی دوزبانه — آماده فروش در سراسر جهان',

      goToStore: 'رفتن به فروشگاه ←',

      back: '→ بازگشت',

      features: [
        {
          icon: '🌐',
          title: 'چند زبانه',
          desc:
            'پشتیبانی از فارسی، انگلیسی، عربی و هر زبان دیگری. شامل چیدمان راست‌به‌چپ.',
        },

        {
          icon: '💰',
          title: 'چند ارزی',
          desc:
            'تعریف ارزها با نماد، تعداد اعشار و نرخ تبدیل دلخواه.',
        },

        {
          icon: '📦',
          title: 'مدیریت محصولات',
          desc:
            'افزودن محصول با نام چندزبانه، قیمت‌های متعدد، تصاویر و ویدیو.',
        },

        {
          icon: '📑',
          title: 'تب‌های صفحات',
          desc:
            'تب‌های ناوبری قابل تنظیم — درباره ما، سوالات متداول، تماس و هر صفحه‌ای.',
        },

        {
          icon: '🗂',
          title: 'درخت دسته‌بندی',
          desc:
            'دسته‌بندی نامحدود برای سازماندهی محصولات به هر شکلی.',
        },

        {
          icon: '🚚',
          title: 'حمل‌ونقل و پرداخت',
          desc:
            'نرخ حمل‌ونقل و درگاه‌های پرداخت یکپارچه.',
        },
      ],
    },
  },
};

const apps = [
  {
    url: 'https://arzook.ca',
    icon: arzook,
    color: '#8B173C',
  },
];

export default function App() {
  const [lang, setLang] = useState('fa');
  const [page, setPage] = useState('home');
  const [loggedIn, setLoggedIn] = useState(false);
  const [message, setMessage] = useState('');
  const [authMode, setAuthMode] = useState('login');
  const [resetSent, setResetSent] = useState(false);

  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });

  const txt = t[lang];
  const isFa = lang === 'fa';

  const navigate = (target) => {
    setPage(target);

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const getCompanyInfoLabel = (key) => {
    const labels = {
      established: isFa
        ? 'سال تأسیس'
        : 'Established',

      registrationDate: isFa
        ? 'تاریخ ثبت'
        : 'Registration Date',

      legalType: isFa
        ? 'نوع شرکت'
        : 'Legal Type',

      nationalId: isFa
        ? 'شناسه ملی'
        : 'National ID',

      registrationNumber: isFa
        ? 'شماره ثبت'
        : 'Registration Number',

      registeredOffice: isFa
        ? 'مرکز ثبت‌شده'
        : 'Registered Office',
    };

    return labels[key];
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f5f5f5',
        fontFamily:
          'Tahoma, Vazirmatn, Arial, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        direction: isFa ? 'rtl' : 'ltr',
      }}
    >
      {/* Language Toggle */}

      <div
        style={{
          position: 'fixed',
          top: 12,
          right: 16,
          zIndex: 99,
          display: 'flex',
          borderRadius: 6,
          overflow: 'hidden',
          border: '1px solid #444',
          direction: 'ltr',
        }}
      >
        <button
          onClick={() => setLang('fa')}
          style={{
            padding: '8px 12px',
            border: 'none',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 600,
            background:
              lang === 'fa'
                ? '#fff'
                : '#1a1a2e',
            color:
              lang === 'fa'
                ? '#1a1a2e'
                : '#888',
          }}
        >
          FA
        </button>

        <button
          onClick={() => setLang('en')}
          style={{
            padding: '8px 12px',
            border: 'none',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 600,
            background:
              lang === 'en'
                ? '#fff'
                : '#1a1a2e',
            color:
              lang === 'en'
                ? '#1a1a2e'
                : '#888',
          }}
        >
          EN
        </button>
      </div>

      {/* Header */}

      <header
        style={{
          background: '#1a1a2e',
          color: '#fff',
          padding: '28px 20px 20px',
          textAlign: 'center',
        }}
      >
        <img
          src="/logo.png"
          alt="Cirook logo"
          style={{
            width: 100,
            height: 80,
            objectFit: 'cover',
            cursor: 'pointer',
          }}
          onClick={() => navigate('home')}
        />

        <h1
          style={{
            marginTop: '-8px',
            marginBottom: 20,
            fontSize: 36,
            letterSpacing: 2,
            cursor: 'pointer',
          }}
          onClick={() => navigate('home')}
        >
          {txt.contact.company}
        </h1>

        {/* Navigation */}

        <nav
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
          }}
        >
          {[
            ['home', txt.nav.home],
            ['customers', txt.nav.customers],
            ['about', txt.nav.about],
            ['contact', txt.nav.contact],
            [
              'login',
              loggedIn
                ? txt.auth.signOut
                : txt.nav.login,
            ],
            ...(loggedIn
              ? [['messages', txt.nav.messages]]
              : []),
          ].map(([key, label]) => (
            <button
              key={key}
              onClick={() => {
                if (key === 'login' && loggedIn) {
                  setLoggedIn(false);
                  navigate('home');
                  return;
                }

                navigate(key);
              }}
              style={{
                border: 'none',
                borderRadius: 6,
                padding: '9px 16px',
                background:
                  page === key
                    ? '#fff'
                    : 'rgba(255,255,255,0.08)',
                color:
                  page === key
                    ? '#1a1a2e'
                    : '#ddd',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              {label}
            </button>
          ))}
        </nav>
      </header>

      {/* HOME */}

      {page === 'home' && (
        <main
          style={{
            flex: 1,
            padding: '40px 24px',
            maxWidth: 1100,
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: '28px 30px',
              boxShadow:
                '0 2px 12px rgba(0,0,0,0.07)',
              marginBottom: 35,
            }}
          >
            <p
              style={{
                margin: 0,
                color: '#222',
                fontSize: 16,
                textAlign: isFa
                  ? 'right'
                  : 'justify',
                lineHeight: 1.9,
                whiteSpace: 'pre-line',
              }}
            >
              {txt.tagline}
            </p>
          </div>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 24,
              justifyContent: 'center',
            }}
          >
            {apps.map((app, i) => (
              <a
                key={i}
                href={app.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  cursor: 'pointer',
                }}
              >
                <div
                  style={{
                    width: 260,
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow:
                      '0 2px 12px rgba(0,0,0,0.1)',
                    overflow: 'hidden',
                    transition:
                      'transform 0.15s, box-shadow 0.15s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform =
                      'translateY(-4px)';

                    e.currentTarget.style.boxShadow =
                      '0 8px 24px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform =
                      '';

                    e.currentTarget.style.boxShadow =
                      '0 2px 12px rgba(0,0,0,0.1)';
                  }}
                >
                  <div
                    style={{
                      background: app.color,
                      height: 80,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src={app.icon}
                      alt=""
                      style={{
                        width: 50,
                        height: 50,
                        objectFit: 'contain',
                      }}
                    />
                  </div>

                  <div
                    style={{
                      padding: '16px 20px',
                    }}
                  >
                    <h2
                      style={{
                        margin: '0 0 8px',
                        fontSize: 18,
                        color: '#111',
                        textAlign: 'center',
                      }}
                    >
                      {txt.apps[i].name}
                    </h2>

                    <p
                      style={{
                        margin: 0,
                        fontSize: 13,
                        color: '#666',
                        lineHeight: 1.7,
                        textAlign: isFa
                          ? 'right'
                          : 'left',
                      }}
                    >
                      {txt.apps[i].description}
                    </p>
                  </div>

                  <div
                    style={{
                      padding: '10px 20px',
                      borderTop:
                        '1px solid #f0f0f0',
                      fontSize: 12,
                      color: app.color,
                      fontWeight: 600,
                    }}
                  >
                    {txt.open}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </main>
      )}

      {/* OUR CUSTOMERS */}

      {page === 'customers' && (
        <main
          style={{
            flex: 1,
            padding: '50px 24px',
            maxWidth: 1000,
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}
        >
          <h2
            style={{
              fontSize: 32,
              color: '#111',
              marginBottom: 10,
            }}
          >
            {txt.customers.title}
          </h2>

          <p
            style={{
              color: '#666',
              fontSize: 16,
              marginBottom: 35,
            }}
          >
            {txt.customers.subtitle}
          </p>

          <div
            style={{
              background: '#fff',
              borderRadius: 14,
              overflow: 'hidden',
              boxShadow:
                '0 3px 15px rgba(0,0,0,0.08)',
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            <div
              style={{
                background: '#8B173C',
                minHeight: 220,
                flex: '1 1 280px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={arzook}
                alt="Arzook.ca"
                style={{
                  width: 110,
                  height: 110,
                  objectFit: 'contain',
                }}
              />
            </div>

            <div
              style={{
                flex: '2 1 400px',
                padding: 35,
              }}
            >
              <h3
                style={{
                  marginTop: 0,
                  fontSize: 25,
                  color: '#111',
                }}
              >
                {txt.customers.arzookTitle}
              </h3>

              <p
                style={{
                  color: '#555',
                  lineHeight: 1.9,
                  fontSize: 15,
                }}
              >
                {txt.customers.arzookDescription}
              </p>

              <a
                href="https://arzook.ca"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  marginTop: 15,
                  background: '#8B173C',
                  color: '#fff',
                  padding: '12px 22px',
                  borderRadius: 7,
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                {txt.customers.visit}
              </a>
            </div>
          </div>
        </main>
      )}

      {/* ABOUT */}

      {page === 'about' && (
        <main
          style={{
            flex: 1,
            padding: '50px 24px',
            maxWidth: 900,
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}
        >
          <h2
            style={{
              fontSize: 32,
              color: '#111',
              marginBottom: 30,
            }}
          >
            {txt.about.title}
          </h2>

          {/* About Cirook */}

          <section
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 30,
              marginBottom: 22,
              boxShadow:
                '0 2px 10px rgba(0,0,0,0.06)',
            }}
          >
            <h3
              style={{
                marginTop: 0,
                fontSize: 23,
              }}
            >
              {txt.about.introTitle}
            </h3>

            <p
              style={{
                color: '#555',
                lineHeight: 2,
                whiteSpace: 'pre-line',
                fontSize: 15,
              }}
            >
              {txt.about.intro}
            </p>
          </section>

          {/* Company Information */}

          <section
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 30,
              marginBottom: 22,
              boxShadow:
                '0 2px 10px rgba(0,0,0,0.06)',
            }}
          >
            <h3
              style={{
                marginTop: 0,
                fontSize: 23,
                color: '#111',
              }}
            >
              {txt.about.companyInfoTitle}
            </h3>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  'repeat(auto-fit, minmax(240px, 1fr))',
                gap: 15,
                marginTop: 20,
              }}
            >
              {Object.entries(
                txt.about.companyInfo
              ).map(([key, value]) => (
                <div
                  key={key}
                  style={{
                    background: '#f7f7f7',
                    borderRadius: 8,
                    padding: '16px 18px',
                  }}
                >
                  <div
                    style={{
                      color: '#777',
                      fontSize: 13,
                      marginBottom: 6,
                    }}
                  >
                    {getCompanyInfoLabel(key)}
                  </div>

                  <div
                    style={{
                      color: '#222',
                      fontSize: 15,
                      fontWeight: 600,
                      direction:
                        key === 'nationalId' ||
                        key === 'registrationNumber' ||
                        key === 'registeredCapital'
                          ? 'ltr'
                          : isFa
                          ? 'rtl'
                          : 'ltr',
                      unicodeBidi: 'plaintext',
                    }}
                  >
                    {value}
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Our Activities */}

          <section
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 30,
              marginBottom: 22,
              boxShadow:
                '0 2px 10px rgba(0,0,0,0.06)',
            }}
          >
            <h3
              style={{
                marginTop: 0,
                fontSize: 23,
                color: '#111',
              }}
            >
              {txt.about.activityTitle}
            </h3>

            <p
              style={{
                color: '#555',
                lineHeight: 2,
                whiteSpace: 'pre-line',
                fontSize: 15,
                marginBottom: 0,
              }}
            >
              {txt.about.activityText}
            </p>
          </section>

          {/* Trusted Third Party */}

          <section
            style={{
              background: '#1a1a2e',
              color: '#fff',
              borderRadius: 12,
              padding: 30,
              marginBottom: 22,
            }}
          >
            <div
              style={{
                display: 'inline-block',
                background: '#fff',
                color: '#1a1a2e',
                borderRadius: 6,
                padding: '5px 10px',
                fontSize: 12,
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              TTP
            </div>

            <h3
              style={{
                marginTop: 0,
                fontSize: 23,
              }}
            >
              {txt.about.ttpTitle}
            </h3>

            <p
              style={{
                color: '#ddd',
                lineHeight: 2,
                whiteSpace: 'pre-line',
                fontSize: 15,
              }}
            >
              {txt.about.ttpText}
            </p>
          </section>

          {/* Mission */}

          <section
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 30,
              boxShadow:
                '0 2px 10px rgba(0,0,0,0.06)',
            }}
          >
            <h3
              style={{
                marginTop: 0,
                fontSize: 23,
              }}
            >
              {txt.about.missionTitle}
            </h3>

            <p
              style={{
                color: '#555',
                lineHeight: 2,
                fontSize: 15,
              }}
            >
              {txt.about.missionText}
            </p>
          </section>
        </main>
      )}

      {/* CONTACT */}

      {page === 'contact' && (
        <main
          style={{
            flex: 1,
            padding: '50px 24px',
            maxWidth: 800,
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}
        >
          <h2
            style={{
              fontSize: 32,
              color: '#111',
              marginBottom: 10,
            }}
          >
            {txt.contact.title}
          </h2>

          <p
            style={{
              color: '#666',
              fontSize: 16,
              marginBottom: 30,
            }}
          >
            {txt.contact.subtitle}
          </p>

          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 35,
              boxShadow:
                '0 2px 12px rgba(0,0,0,0.07)',
            }}
          >
            <h3
              style={{
                marginTop: 0,
                fontSize: 22,
              }}
            >
              {txt.contact.company}
            </h3>

            <p
              style={{
                color: '#666',
                lineHeight: 1.8,
              }}
            >
              {txt.contact.message}
            </p>

            {/* Email */}

            <div
              style={{
                marginTop: 25,
                padding: 20,
                background: '#f7f7f7',
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                gap: 15,
              }}
            >
              <div style={{ fontSize: 24 }}>
                ✉️
              </div>

              <div>
                <a
                  href={`mailto:${txt.contact.emailValue}`}
                  dir="ltr"
                  style={{
                    color: '#333348',
                    fontSize: 17,
                    fontWeight: 600,
                    textDecoration: 'none',
                  }}
                >
                  {txt.contact.emailValue}
                </a>
              </div>
            </div>

            {/* Phone */}

            <div
              style={{
                marginTop: 15,
                padding: 20,
                background: '#f7f7f7',
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                gap: 15,
              }}
            >
              <div style={{ fontSize: 24 }}>
                📞
              </div>

              <div>
                <a
                  href="tel:+989104868798"
                  dir="ltr"
                  style={{
                    color: '#333348',
                    fontSize: 17,
                    fontWeight: 600,
                    direction: 'ltr',
                    unicodeBidi: 'plaintext',
                    textDecoration: 'none',
                  }}
                >
                  {txt.contact.phone}
                </a>
              </div>
            </div>

            {/* Address */}

            <div
              style={{
                marginTop: 15,
                padding: 20,
                background: '#f7f7f7',
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                gap: 15,
              }}
            >
              <div style={{ fontSize: 24 }}>
                📍
              </div>

              <div>
                <div
                  style={{
                    color: '#333348',
                    fontSize: 17,
                    fontWeight: 600,
                  }}
                >
                  {txt.contact.address}
                </div>
              </div>
            </div>
          </div>
        </main>
      )}

      {/* LOGIN / FORGOT PASSWORD */}

      {page === 'login' && (
        <main
          style={{
            flex: 1,
            padding: '60px 24px',
            maxWidth: 460,
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 14,
              padding: 35,
              boxShadow:
                '0 4px 18px rgba(0,0,0,0.08)',
            }}
          >
            {authMode === 'login' ? (
              <>
                <h2
                  style={{
                    margin: '0 0 8px',
                    fontSize: 30,
                    color: '#111',
                  }}
                >
                  {txt.auth.loginTitle}
                </h2>

                <p
                  style={{
                    color: '#666',
                    marginBottom: 28,
                  }}
                >
                  {txt.auth.loginSubtitle}
                </p>

                <form
                  onSubmit={(e) => {
                    e.preventDefault();

                    setMessage(
                      txt.auth.failedMessage
                    );

                    setCredentials({
                      email: '',
                      password: '',
                    });

                    setLoggedIn(false);
                  }}
                >
                  {message && (
                    <div
                      style={{
                        color: '#d32f2f',
                        background: '#fff5f5',
                        border:
                          '1px solid #f1b5b5',
                        borderRadius: 8,
                        padding: '12px 14px',
                        marginBottom: 20,
                        fontSize: 14,
                        lineHeight: 1.6,
                      }}
                    >
                      {message}
                    </div>
                  )}

                  <label
                    style={{
                      display: 'block',
                      marginBottom: 7,
                      fontWeight: 600,
                    }}
                  >
                    {txt.auth.email}
                  </label>

                  <input
                    type="email"
                    required
                    value={credentials.email}
                    onChange={(e) => {
                      setMessage('');

                      setCredentials({
                        ...credentials,
                        email: e.target.value,
                      });
                    }}
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      padding: '12px 13px',
                      border: '1px solid #ddd',
                      borderRadius: 8,
                      marginBottom: 18,
                      fontSize: 15,
                      direction: 'ltr',
                    }}
                  />

                  <label
                    style={{
                      display: 'block',
                      marginBottom: 7,
                      fontWeight: 600,
                    }}
                  >
                    {txt.auth.password}
                  </label>

                  <input
                    type="password"
                    required
                    value={credentials.password}
                    onChange={(e) => {
                      setMessage('');

                      setCredentials({
                        ...credentials,
                        password: e.target.value,
                      });
                    }}
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      padding: '12px 13px',
                      border: '1px solid #ddd',
                      borderRadius: 8,
                      marginBottom: 10,
                      fontSize: 15,
                      direction: 'ltr',
                    }}
                  />

                  <button
                    type="button"
                    onClick={() => {
                      setAuthMode('forgot');
                      setResetSent(false);
                      setMessage('');
                    }}
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      color: '#1a1a2e',
                      cursor: 'pointer',
                      fontWeight: 600,
                      marginBottom: 22,
                    }}
                  >
                    {txt.auth.forgot}
                  </button>

                  <button
                    type="submit"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: 8,
                      padding: '13px 18px',
                      background: '#1a1a2e',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: 16,
                      fontWeight: 700,
                    }}
                  >
                    {txt.auth.loginButton}
                  </button>
                </form>
              </>
            ) : (
              <>
                <h2
                  style={{
                    margin: '0 0 8px',
                    fontSize: 30,
                    color: '#111',
                  }}
                >
                  {txt.auth.forgotTitle}
                </h2>

                <p
                  style={{
                    color: '#666',
                    marginBottom: 28,
                  }}
                >
                  {txt.auth.forgotSubtitle}
                </p>

                {resetSent ? (
                  <div
                    style={{
                      background: '#f1f7f3',
                      borderRadius: 8,
                      padding: 15,
                      color: '#245b38',
                      lineHeight: 1.7,
                      marginBottom: 20,
                    }}
                  >
                    {txt.auth.resetSent}
                  </div>
                ) : (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      setResetSent(true);
                    }}
                  >
                    <label
                      style={{
                        display: 'block',
                        marginBottom: 7,
                        fontWeight: 600,
                      }}
                    >
                      {txt.auth.email}
                    </label>

                    <input
                      type="email"
                      required
                      value={credentials.email}
                      onChange={(e) =>
                        setCredentials({
                          ...credentials,
                          email: e.target.value,
                        })
                      }
                      style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: '12px 13px',
                        border: '1px solid #ddd',
                        borderRadius: 8,
                        marginBottom: 18,
                        fontSize: 15,
                        direction: 'ltr',
                      }}
                    />

                    <button
                      type="submit"
                      style={{
                        width: '100%',
                        border: 'none',
                        borderRadius: 8,
                        padding: '13px 18px',
                        background: '#1a1a2e',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: 16,
                        fontWeight: 700,
                      }}
                    >
                      {txt.auth.sendReset}
                    </button>
                  </form>
                )}

                <button
                  onClick={() => {
                    setAuthMode('login');
                    setResetSent(false);
                    setMessage('');
                  }}
                  style={{
                    marginTop: 18,
                    background: 'none',
                    border: 'none',
                    color: '#1a1a2e',
                    cursor: 'pointer',
                    fontWeight: 600,
                  }}
                >
                  {txt.auth.backLogin}
                </button>
              </>
            )}
          </div>
        </main>
      )}

      {/* MESSAGES */}

      {page === 'messages' && (
        <main
          style={{
            flex: 1,
            padding: '50px 24px',
            maxWidth: 850,
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}
        >
          {!loggedIn ? (
            <div
              style={{
                background: '#fff',
                borderRadius: 14,
                padding: 35,
                boxShadow:
                  '0 3px 15px rgba(0,0,0,0.08)',
                textAlign: 'center',
              }}
            >
              <h2 style={{ marginTop: 0 }}>
                {txt.auth.loginTitle}
              </h2>

              <p style={{ color: '#666' }}>
                {txt.auth.loginSubtitle}
              </p>

              <button
                onClick={() => navigate('login')}
                style={{
                  border: 'none',
                  borderRadius: 8,
                  padding: '12px 22px',
                  background: '#1a1a2e',
                  color: '#fff',
                  cursor: 'pointer',
                  fontWeight: 700,
                }}
              >
                {txt.nav.login}
              </button>
            </div>
          ) : (
            <>
              <h2
                style={{
                  fontSize: 32,
                  color: '#111',
                  marginBottom: 8,
                }}
              >
                {txt.auth.messagesTitle}
              </h2>

              <p
                style={{
                  color: '#666',
                  marginBottom: 30,
                }}
              >
                {txt.auth.messagesSubtitle}
              </p>

              <div
                style={{
                  background: '#fff',
                  borderRadius: 14,
                  padding: 35,
                  boxShadow:
                    '0 3px 15px rgba(0,0,0,0.08)',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    fontSize: 42,
                    marginBottom: 12,
                  }}
                >
                  ✉️
                </div>

                <p
                  style={{
                    color: '#666',
                    margin: 0,
                  }}
                >
                  {txt.auth.noMessages}
                </p>
              </div>
            </>
          )}
        </main>
      )}

      {/* STORE */}

      {page === 'store' && (
        <main
          style={{
            flex: 1,
            padding: '40px 24px',
            maxWidth: 800,
            margin: '0 auto',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <button
            onClick={() => navigate('home')}
            style={{
              background: 'none',
              border: 'none',
              color: '#ff9900',
              fontSize: 15,
              cursor: 'pointer',
              fontWeight: 600,
              marginBottom: 24,
            }}
          >
            {txt.store.back}
          </button>

          <h2
            style={{
              fontSize: 28,
              margin: '0 0 8px',
              color: '#111',
            }}
          >
            {txt.store.title}
          </h2>

          <p
            style={{
              fontSize: 16,
              color: '#666',
              margin: '0 0 32px',
            }}
          >
            {txt.store.subtitle}
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                'repeat(auto-fill, minmax(220px, 1fr))',
              gap: 20,
            }}
          >
            {txt.store.features.map((f, i) => (
              <div
                key={i}
                style={{
                  background: '#fff',
                  borderRadius: 10,
                  padding: 20,
                  boxShadow:
                    '0 2px 8px rgba(0,0,0,0.07)',
                }}
              >
                <div
                  style={{
                    fontSize: 32,
                    marginBottom: 10,
                  }}
                >
                  {f.icon}
                </div>

                <h3
                  style={{
                    margin: '0 0 6px',
                    fontSize: 16,
                    color: '#111',
                  }}
                >
                  {f.title}
                </h3>

                <p
                  style={{
                    margin: 0,
                    fontSize: 13,
                    color: '#666',
                    lineHeight: 1.5,
                  }}
                >
                  {f.desc}
                </p>
              </div>
            ))}
          </div>

          <div
            style={{
              marginTop: 36,
              textAlign: 'center',
            }}
          >
            <p
              style={{
                fontSize: 13,
                color: '#888',
                marginBottom: 12,
              }}
            >
              {lang === 'en'
                ? 'Demo admin login — Username: admin | Password: admin123'
                : 'ورود ادمین دمو — نام کاربری: admin | رمز عبور: admin123'}
            </p>

            <a
              href="https://bilingualshop-production.up.railway.app/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: '#ff9900',
                color: '#fff',
                padding: '14px 32px',
                borderRadius: 8,
                fontSize: 16,
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              {txt.store.goToStore}
            </a>
          </div>
        </main>
      )}

      {/* Footer */}

      <footer
        style={{
          background: '#1a1a2e',
          color: '#fff',
          textAlign: 'center',
          padding: '24px 20px',
          fontSize: 14,
        }}
      >
        <p style={{ margin: 0 }}>
          {txt.footer}
        </p>
      </footer>
    </div>
  );
}
